<template>
  <el-dialog title="" :visible.sync="dialogVisible" width="600px" custom-class="login-dialog" :close-on-click-modal="false" @update:visible="updateVisible">
    <div class="login-content">
      <div class="login-header">
        <img :src="require('@/assets/img/home/logo.png')" alt="logo" class="login-logo" />
      </div>
      <el-tabs v-model="activeTab" class="login-tabs">
        <el-tab-pane label="账号登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="login-form">
            <el-form-item prop="username">
              <el-input v-model="loginForm.mobile" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码" show-password></el-input>
            </el-form-item>
            <div class="form-footer"></div>
            <el-form-item prop="agreement" class="agreement-item">
              <el-checkbox v-model="loginForm.agreement">
                我已阅读并同意
                <el-button type="text" class="link-btn" @click.stop="openUserAgreement">《用户协议》</el-button>
              </el-checkbox>
            </el-form-item>
            <el-button type="primary" class="login-btn" @click="handleLogin" :loading="loading" :disabled="!loginForm.agreement">登 录</el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="注册账号" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="login-form">
            <el-form-item prop="phone">
              <el-input v-model="registerForm.mobile" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码" show-password></el-input>
            </el-form-item>
            <el-form-item prop="agreement" class="agreement-item">
              <el-checkbox v-model="registerForm.agreement">
                我已阅读并同意
                <el-button type="text" class="link-btn" @click.stop="openUserAgreement">《用户协议》</el-button>
              </el-checkbox>
            </el-form-item>
            <el-button type="primary" class="login-btn" @click="handleRegister" :loading="registerLoading" :disabled="!registerForm.agreement">立即注册</el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import loginApi from '@/api/login'
import { Session } from '@/utils/storage'

export default {
  name: 'LoginDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: this.value,
      activeTab: 'login',
      loginForm: {
        mobile: '',
        password: '',
        remember: false,
        agreement: false
      },
      loading: false,
      loginRules: {
        mobile: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        agreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请阅读并同意用户协议和隐私政策'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      registerForm: {
        mobile: '',
        password: '',
        agreement: false
      },
      registerRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        agreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请阅读并同意用户协议和隐私政策'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      registerLoading: false
    }
  },
  watch: {
    value(newVal) {
      this.dialogVisible = newVal
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('input', val)
    },
    openUserAgreement() {
      const currentLocation = window.location.origin
      window.open(`${currentLocation}/pc/userAgreement`, '_blank')
    },
    openPrivacyPolicy() {
      // 打开隐私政策
      this.$message.info('打开隐私政策')
    },
    // 保存用户信息到session
    saveUserInfo(data) {
      console.log('saveUserInfo', data)
      Session.set('userInfo', { ...data, mobile: this.loginForm.mobile || data.mobile })
    },
    handleLogin() {
      if (!this.loginForm.agreement) {
        this.$message.warning('请阅读并同意用户协议')
        return
      }
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const params = {
              mobile: this.loginForm.mobile,
              password: this.loginForm.password
            }
            const res = await loginApi.login(params)
            if (res.data.code === 200) {
              // 保存用户信息
              this.saveUserInfo(res.data.data)
              this.dialogVisible = false
              this.$emit('input', false)
              this.$message.success('登录成功')
              this.$emit('login-success')
            } else {
              this.$message.error(res.data.msg || '登录失败')
            }
          } catch (error) {
            this.$message.error('登录失败，请稍后重试')
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleRegister() {
      if (!this.registerForm.agreement) {
        this.$message.warning('请阅读并同意用户协议')
        return
      }
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          try {
            this.registerLoading = true
            const params = {
              mobile: this.registerForm.mobile,
              password: this.registerForm.password
            }
            const res = await loginApi.register(params)
            if (res.data.code == 200) {
              // 注册成功后自动登录
              this.$message.success('注册成功')
              this.$emit('input', false)
              // 保存用户信息
              this.saveUserInfo({ ...res.data.data, mobile: this.registerForm.mobile })
              this.$emit('register-success')
            } else {
              this.$message.error(res.data.msg || '注册失败')
            }
          } catch (error) {
          } finally {
            this.registerLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

::v-deep .login-dialog {
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      z-index: 1;
      .el-dialog__close {
        color: #666;
      }
    }
  }

  .login-content {
    padding: 0 40px;

    .login-header {
      text-align: center;
      margin-bottom: 20px;

      .login-logo {
        width: 80px;
        margin-bottom: 15px;
      }
    }

    .login-tabs {
      .el-tabs__nav {
        width: 100%;
        display: flex;

        .el-tabs__item {
          flex: 1;
          text-align: center;
          font-size: 16px;
          height: 45px;
          line-height: 45px;

          &.is-active {
            color: $primary-color;
          }
        }
      }

      .el-tabs__nav-wrap::after {
        height: 1px;
      }

      .el-tabs__active-bar {
        background-color: $primary-color;
      }
    }

    .login-form {
      margin-top: 20px;

      .el-input {
        margin-bottom: 5px;

        ::v-deep .el-input__inner {
          height: 45px;
          line-height: 45px;
          border-radius: 4px;

          &:focus {
            border-color: $primary-color;
          }
        }

        ::v-deep .el-input__prefix {
          font-size: 18px;
          color: #999;
        }
      }

      .form-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0 20px;

        .el-checkbox {
          color: #666;
        }

        .forget-pwd {
          color: #666;
          &:hover {
            color: $primary-color;
          }
        }
      }

      .agreement-item {
        margin-bottom: 15px;

        .el-checkbox {
          color: #666;
          font-size: 12px;

          .link-btn {
            padding: 0;
            font-size: 12px;
            color: $primary-color;

            &:hover {
              color: $primary-hover-color;
            }
          }
        }
      }

      .login-btn {
        width: 100%;
        height: 45px;
        font-size: 16px;
        margin-bottom: 15px;

        &:hover:not(:disabled),
        &:focus:not(:disabled) {
          background: $primary-hover-color;
          border-color: $primary-hover-color;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
